import { useState, useEffect } from "react";
import {
  Avatar,
  Button,
  Input,
  Form,
  Select,
  Row,
  Col,
  Space,
  Spin,
  Tooltip,
  message,
} from "antd";
import {
  PlusOutlined,
  DeleteOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import UserIcon from "../../../../assets/images/icons/userLogo.svg";
import { useLocation } from "react-router-dom";
import { useStore } from "../../../../store";
import { TAB_KEYS } from "../../../../config";
import { useTab } from "../../../../custom-hooks/useTab";
import { useConnectsuForm } from "../../../../custom-hooks/useConnectsuForm";
import { getFormFieldValue } from "../../../../utils";
import ImageLabel from "../../../image-label";
import ImageSlider from "../../../slider/ImageSlider";
import './carousel.scss';
export default function CarouselComponent({
  dataLoader,
  form,
  _,
  loader: formDataLoader,
  tabHandleSaveClick,
}) {
  const { state } = useLocation();
  const tabKey = state;
  const { tabData } = useStore();
  const whichTab = TAB_KEYS.corousel;
  const { deleteSingleItem, postLoader } = useTab();
  const { updateImage } = useConnectsuForm();
  const [tabDataObj, setTabDataObj] = useState({ corousel: tabData?.corousel });
  const [loader, setLoader] = useState(formDataLoader || true);

  // new states for add/clear logic
  const [canAddNew, setCanAddNew] = useState(true);
  const [hasUnsavedItem, setHasUnsavedItem] = useState(false);

  const rotateRightByOne = (arr = []) =>
    arr.length ? [arr[arr.length - 1], ...arr.slice(0, -1)] : [];

  useEffect(() => {
    localStorage.setItem("tab", "CAROUSEL");
  }, []);

  useEffect(() => {
    // form.resetFields();
    refreshUnsavedState();
    setTimeout(() => {
      setLoader(false);
    }, 1000);
  }, [tabData[whichTab]]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (tabData?.corousel?.length === 0) {
        setHasUnsavedItem(true);
      } else {
        setHasUnsavedItem(false);
      }
    }, 500);

    return () => clearTimeout(timer); // cleanup for safety
  }, [tabData?.corousel]);

  useEffect(() => {
    setTabDataObj({
      corousel: rotateRightByOne(tabData?.corousel),
    });
  }, [tabData?.corousel, tabData]);

  const findValue = (i, key) => getFormFieldValue(form, whichTab, i, key);

  const SelectChangeHandler = (e, i) => {
    form.setFieldValue([whichTab, i, "mediaLink", "url"], "");
  };

  // ----------------- Handlers -----------------
  const handleAddMore = () => {
    if (!canAddNew) {
      message.warning(
        "You must save the current item before you can add a new one."
      );
      return;
    }
    const currentList = form.getFieldValue(whichTab) || [];
    const unsavedItem = currentList.find(
      (item) =>
        !item?.id &&
        (item?.title?.trim() ||
          item?.mediaLink?.url?.trim() ||
          item?.mediaLink?.mediaType ||
          item?.blob)
    );
    if (unsavedItem) {
      message.warning(
        "You must save the current item before you can add a new one."
      );
      return;
    }
    const tempList = [...currentList];
    tempList.splice(1, 0, {
      title: "",
      mediaLink: { mediaType: undefined, url: "" },
      media: null,
    });
    const newList = [...tempList];
    form.setFieldsValue({ [whichTab]: newList });
    setCanAddNew(false);
    setHasUnsavedItem(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleSave = () => {
    console.log("Submitting form for tab:", whichTab);
    form.submit();
    setTabDataObj({});
    // tabHandleSaveClick(form);

    setTimeout(() => {
      setCanAddNew(true);
      setHasUnsavedItem(false);
    }, 500);
  };

  const refreshUnsavedState = () => {
    const currentList = form.getFieldValue(whichTab) || [];
    const unsavedItem = currentList.find(
      (item) =>
        !item?.id &&
        (item?.title?.trim() ||
          item?.mediaLink?.url?.trim() ||
          item?.mediaLink?.mediaType)
    );
    setCanAddNew(!unsavedItem);
    setHasUnsavedItem(!!unsavedItem);
  };

  const handleClear = () => {
    const currentList = form.getFieldValue(whichTab) || [];
    const updatedList = currentList.map((item) =>
      !item?.id
        ? {
          title: "",
          mediaLink: { mediaType: undefined, url: "" },
          media: null,
        }
        : item
    );
    form.setFieldsValue({ [whichTab]: updatedList });
    // refreshUnsavedState();
  };

  const handleDelete = (i, name, remove) => {
    setTabDataObj({});
    const item = form.getFieldValue(whichTab)?.[i];
    const id = item?.id;
    if (id) {
      deleteSingleItem(whichTab, id, form);
    } else {
      remove(name);
    }
    setTimeout(() => {
      const currentList = form.getFieldValue(whichTab) || [];
      const unsavedItem = currentList.find(
        (it) =>
          !it?.id &&
          (it?.title?.trim() ||
            it?.mediaLink?.url?.trim() ||
            it?.mediaLink?.mediaType)
      );
      setCanAddNew(!unsavedItem);
      setHasUnsavedItem(!!unsavedItem);
      refreshUnsavedState();
    }, 100);
  };

  useEffect(() => {
    if (tabDataObj?.[whichTab]?.length) {
      form.setFieldsValue({
        [whichTab]: tabDataObj[whichTab]
      });
    }
  }, [tabDataObj, form, whichTab]);

  // ---------------- Loader ----------------
  if (dataLoader || postLoader || loader) {
    return (
      <div className="data-loader">
        <Spin tip="Loading" size="large" />
      </div>
    );
  }

  return tabDataObj.corousel ? (
    <div>
      <Row className="rowBody" gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        {tabKey === whichTab ? (
          <>
            <Col
              className="gutter-row tabContent"
              span={15}
              style={{ paddingRight: "25px" }}
            >
              <Form.List
                name={whichTab}
                initialValue={
                  tabDataObj &&
                    tabDataObj[whichTab] &&
                    tabDataObj[whichTab].length > 0
                    ? tabDataObj[whichTab]
                    : [""]
                }
              >
                {(fields, { remove }) => (
                  <>
                    <div className="inputBody">
                      <label></label>
                      <div style={{ textAlign: "right" }}>
                        {hasUnsavedItem && (
                          <Button
                            className="cancelBtn"
                            type="button"
                            onClick={handleClear}
                          >
                            Clear
                          </Button>
                        )}

                        <Button className="greenBtn" onClick={handleAddMore}>
                          Add <PlusOutlined />
                        </Button>
                      </div>
                    </div>

                    {fields.map(({ key, name, ...restField }, i) => {
                      return (
                        <Space
                          key={key}
                          style={{
                            display: "block",
                            marginBottom: 8,
                            paddingRight: "40px",
                          }}
                          align="baseline"
                          className={`card-item businessCard ${i === 0 ? 'main-carousel-card' : ''}`}
                        >
                          {/* === RESTORED: Microsite carousel main card === */}
                          {i === 0 && (
                            <div
                              className="font-bold"
                              style={{
                                textAlign: "center",
                                paddingBottom: "10px",
                              }}
                            >
                              <strong>Main Video/Image</strong>
                            </div>
                          )}

                          {/* Title + Delete */}
                          <div className={`d-flex ${i === 0 ? 'main-carousel-text' : ''}`}>
                            <Form.Item
                              {...restField}
                              className="w-100"
                              label="Video/Image Title"
                              name={[name, "title"]}
                              labelCol={{ span: 5 }}
                              rules={[
                                {
                                  required: true,
                                  message: "Image/Video Title is required",
                                },
                              ]}
                            >
                              <Input
                                placeholder="Image/Video Title"
                                maxLength={40}
                                showCount={{
                                  formatter: ({ count }) => `${count}/40`,
                                }}
                                
                                onKeyDown={(e) => {
                                  const currentValue =
                                    form.getFieldValue([whichTab, name, "title"]) || "";

                                  if (
                                    e.key.length === 1 && // normal characters only
                                    currentValue.length >= 40
                                  ) {
                                    form.setFields([
                                      {
                                        name: [whichTab, name, "title"],
                                        errors: ["Title cannot exceed 40 characters"],
                                      },
                                    ]);
                                  }
                                }}
                                onBlur={() => {
                                  form.setFields([
                                    {
                                      name: [whichTab, name, "title"],
                                      errors: [],
                                    },
                                  ]);
                                }}
                              />
                            </Form.Item>

                            <Form.Item>
                              <div className="remove-btn">
                                {(tabDataObj?.corousel?.length || 0) > 1 &&
                                  i !== 0 && (
                                    <DeleteOutlined
                                      onClick={() =>
                                        handleDelete(i, name, remove)
                                      }
                                    />
                                  )}
                              </div>
                            </Form.Item>
                          </div>

                          {/* Select: Video or Image */}
                          <div className={`d-flex ${i === 0 ? 'main-carousel-text' : ''}`}>
                            <Form.Item
                              {...restField}
                              className="w-100"
                              name={[name, "mediaLink", "mediaType"]}
                              label="Video or Image"
                              labelCol={{ span: 5 }}
                              rules={[
                                {
                                  required: true,
                                  message: "Select any option",
                                },
                              ]}
                            >
                              <Select
                                onChange={(e) => SelectChangeHandler(e, i)}
                                placeholder="Select Option"
                              >
                                <Select.Option value="VIMEO_MEDIA">
                                  Add Vimeo Link
                                </Select.Option>
                                <Select.Option value="SOCIAL_MEDIA">
                                  Add Youtube Link
                                </Select.Option>
                                <Select.Option value="SYNTHESIA_MEDIA">
                                  Add Synthesia Link
                                </Select.Option>
                                <Select.Option value="IMAGE">
                                  Upload Image
                                </Select.Option>
                              </Select>
                            </Form.Item>
                            <Form.Item>
                              <div className="remove-btn">
                                <Tooltip title="Upload Video link or image with size lesser than 2.5MB. For best results, use images and videos with a 16:9 aspect ratio">
                                  <QuestionCircleOutlined />
                                </Tooltip>
                              </div>
                            </Form.Item>
                          </div>

                          {/* Dynamic Fields by Type */}
                          <div className={`${i === 0 ? 'main-carousel-text' : ''}`}>
                            {findValue(i, "type") === "SOCIAL_MEDIA" ? (
                              <Form.Item
                                label="Youtube Link"
                                {...restField}
                                labelCol={{ span: 5 }}
                                name={[name, "mediaLink", "url"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "Youtube link is required",
                                  },
                                ]}
                              >
                                <Input />
                              </Form.Item>
                            ) : findValue(i, "type") === "VIMEO_MEDIA" ? (
                              <Form.Item
                                label="Vimeo Link"
                                labelCol={{ span: 5 }}
                                {...restField}
                                name={[name, "mediaLink", "url"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "Vimeo link is required",
                                  },
                                ]}
                              >
                                <Input />
                              </Form.Item>
                            ) : findValue(i, "type") === "IMAGE" ? (
                              <Form.Item
                                {...restField}
                                label={<ImageLabel label={"Image"} />}
                                colon={false}
                                name="media"
                                className="experienceImg"
                                labelCol={{ span: 5 }}
                                rules={[
                                  {
                                    validator: (_, value) =>
                                      findValue(i, "blob") || findValue(i, "url")
                                        ? Promise.resolve()
                                        : Promise.reject(
                                          new Error("Image is required")
                                        ),
                                  },
                                ]}
                              >
                                {findValue(i, "blob") ? (
                                  <Avatar
                                    src={URL.createObjectURL(
                                      findValue(i, "blob")
                                    )}
                                    alt=""
                                  />
                                ) : findValue(i, "url") ? (
                                  <Avatar src={findValue(i, "url")} alt="" />
                                ) : (
                                  <Avatar src={UserIcon} />
                                )}
                                <label
                                  name="file"
                                  className="fileUploadBtn greenBtn"
                                >
                                  Choose File
                                  <input
                                    accept="image/png, image/gif, image/jpeg"
                                    type="file"
                                    onChange={(e) =>
                                      updateImage(e, i, form, whichTab)
                                    }
                                  />
                                </label>
                              </Form.Item>
                            ) : findValue(i, "type") === "SYNTHESIA_MEDIA" ? (
                              <Form.Item
                                label="Synthesia Link"
                                labelCol={{ span: 5 }}
                                {...restField}
                                name={[name, "mediaLink", "url"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "Synthesia link is required",
                                  },
                                ]}
                              >
                                <Input />
                              </Form.Item>
                            ) : null}
                          </div>

                          {/* Save Button */}
                          <Form.Item
                            className="w-100"
                            style={{ display: "flex", justifyContent: "end" }}
                          >
                            <Button
                              className="saveBtn greenBtn save_align"
                              onClick={() => {
                                handleSave();
                              }}
                            >
                              Save
                            </Button>
                          </Form.Item>
                        </Space>
                      );
                    })}
                  </>
                )}
              </Form.List>
            </Col>

            {/* Right-side slider */}
            <Col className="gutter-row corousel-col" span={6}>
              <ImageSlider
                data={
                  tabDataObj &&
                    tabDataObj[whichTab] &&
                    tabDataObj[whichTab].length > 0
                    ? tabDataObj[whichTab]
                    : [""]
                }
              />
            </Col>
          </>
        ) : null}
      </Row>
    </div>
  ) : (
    ""
  );
}
